export default "__VITE_ASSET__BRxq6VeV__"